import { Pipe, PipeTransform } from '@angular/core';
import { StatusCabecalhoConferenciaDeFatura as Status } from '../../enum/StatusCabecalhoConferenciaDeFatura';

@Pipe({
  name: 'badgeStatusConferenciaDeFatura',
})
export class BadgeStatusCabecalhoConferenciaDeFaturaPipe
  implements PipeTransform
{
  transform(status: Status): string {
    return {
      [Status.Pendente]: 'bg-warning text-dark',
      [Status.Fechado]: 'bg-success text-light',
    }[status];
  }
}
